import React from "react";
import { Layout, Button } from "antd";
import PostsListContainer from "./PostsList/container";
import SideBar from "../../../components/SideBar/container";
const { Header, Content, Footer } = Layout;

function BlogCollection({ addBlogPost }) {
  return (
    <Layout style={{ height: "100vh" }}>
      <SideBar />
      <Layout>
        <Header
          style={{
            textAlign: "left",
            background: "#fff",
            padding: "0 24px",
            borderBottom: "1px solid"
          }}
        >
          <h1>Blog Posts</h1>
          <Button
            type="primary"
            onClick={addBlogPost}
            style={{
              right: "24px",
              top: "14px",
              position: "absolute"
            }}
          >
            Add post
          </Button>
        </Header>
        <Content style={{ backgroundColor: "#fff" }}>
          <div
            style={{ padding: "40px 24px", background: "#fff", minHeight: 360 }}
          >
            <PostsListContainer />
          </div>
        </Content>
        <Footer style={{ textAlign: "center" }}>iLead © 2018</Footer>
      </Layout>
    </Layout>
  );
}

export default BlogCollection;



// WEBPACK FOOTER //
// ./src/pages/Admin/BlogCollection/index.js